var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2393 13.9445V5.71827L18.4389 9.83139L11.2393 13.9445ZM27.2572 3.13007C26.9403 1.93192 26.0053 0.987929 24.8206 0.668078C22.6716 0.0871582 14.0565 0.0871582 14.0565 0.0871582C14.0565 0.0871582 5.44142 0.0871582 3.29238 0.668078C2.10766 0.987929 1.17263 1.93192 0.855781 3.13007C0.28064 5.3016 0.28064 9.83139 0.28064 9.83139C0.28064 9.83139 0.28064 14.3612 0.855781 16.5327C1.17263 17.7309 2.10766 18.6749 3.29238 18.9947C5.44142 19.5756 14.0565 19.5756 14.0565 19.5756C14.0565 19.5756 22.6716 19.5756 24.8206 18.9947C26.0053 18.6749 26.9403 17.7309 27.2572 16.5327C27.8323 14.3612 27.8323 9.83139 27.8323 9.83139C27.8323 9.83139 27.8323 5.3016 27.2572 3.13007Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.9328a0ad435603f0f6f0584583b6bdf1.svg";
export { ForwardRef as ReactComponent };